<!-- @component
	Dialog for admins to re-read a chapter/section/topic of the Google-Docs documentation into the database
-->

<dialog id=updateDocsDialog bind:this={dialog} onclose={closing_dialog}>
	<h3>Dokumentation aktualisieren</h3>
	<div class="close fa icon-square-xmark" onclick={() => dialog.close()}></div>
	<div class=container>
		<Select field=chapter bind:value={chapter} options={chapterOptions} separate onchange={select_chapter} />
		<Select field=section bind:value={section} options={sectionOptions} separate disabled={!chapter} onchange={select_section} />
		<Select field=topic bind:value={topic} options={topicOptions} separate disabled={!section} />
		<div class=buttonBar>
			<button class=miniButton onclick={update_documentation}>Updaten</button>
		</div>
	</div>
</dialog>
<svelte:window onkeydown={(e) => {if (e.key === 'Escape') dialog.close()}} />


<!------------------------------- SCRIPT ------------------------------------->

<script>
	import {view, fetch_data} from "../client.svelte.js";
	import {fetch_documentation, merge_documentation} from "../core.js";
	import Select from "../elements/Select.svelte";
	import {onMount} from "svelte";

	let dialog     // HTML element

	let chapter = $state("")
	let section = $state("")
	let topic = $state("")
	let docsList = $state([])

	let chapterOptions = $derived([...new Set(docsList.map(entry => entry.chapter))].sort())
	let sectionOptions = $derived([...new Set(docsList.filter(entry => entry.chapter === chapter).map(entry => entry.section).filter(Boolean))].sort())
	let topicOptions = $derived([...new Set(docsList.filter(entry => entry.chapter === chapter && entry.section === section).map(entry => entry.topic).filter(Boolean))].sort())

	onMount(async () => {
		docsList = await fetch_documentation()
		dialog.showModal()
	})

	function select_chapter() {
		section = ""
		topic = ""
	}

	function select_section() {
		topic = ""
	}

	async function update_documentation() {
		const part = [chapter, section, topic].filter(Boolean).join("-") || "_"
		console.log(`UPDATE-DOCS: reading in documentation for part '${part}'`)
		const response = await fetch_data(`/readdocs/${part}`)
		if ('docs' in response)
			merge_documentation(response.docs, part)
		dialog.close()
	}

	function closing_dialog() {
		view.close_dialog()
	}
</script>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	dialog
		position: absolute
		margin: 0
		top: 50%
		left: 50%
		transform: translateY(-50%) translateX(-50%)
		min-height: 160px
		background-color: #444444
		overflow: hidden

	.close
		position: absolute
		float: right
		right: 12px
		top: 8px
		font-size: larger
		color: lightgray

	.close:hover
		color: lightcoral

	.container
		display: flex
		flex-direction: column
		gap: 4px
		width: 260px
		margin: 4px
		padding: 8px

	h3
		color: colors.$white
		text-align: center
		margin: 4px

	.buttonBar
		margin: 16px 4px 4px 4px
		display: flex
		justify-content: center

	.miniButton
		width: 138px
</style>
